// src/components/Logo.js
import React from 'react';
import logoImage from '../assets/images/logo.png';

const Logo = ({ size = 'medium', className = '', style = {} }) => {
  const sizes = {
    small: { width: 140, height: 40, borderRadius: 10 },
    medium: { width: 200, height: 90, borderRadius: 12 },
    large: { width: 250, height: 140, borderRadius: 20 },
    sidebar: { width: 245, height: 200, borderRadius: 42 }
  };

  const currentSize = sizes[size] || sizes.medium;

  const logoStyle = {
    width: currentSize.width,
    height: currentSize.height,
    borderRadius: currentSize.borderRadius,
    objectFit: 'contain',
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center',
    ...style
  };

  return (
    <img 
      src={logoImage} 
      alt="TradeHawk Logo" 
      className={`logo-image ${className}`}
      style={logoStyle}
    />
  );
};

export default Logo;